export default "__VITE_ASSET__DJy_SElC__";